<div fxFlex fxLayout="column" fxLayoutGap="10px">
    <div *ngIf="imageVisible" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;" fxLayout="row"
      fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <div  *ngIf="value!=''"  fxLayout="column">
        <span>Figure</span>
        <audio width="350" height="300" controls>
     
            <source [src]="serverPath+value+cid" onerror="this.src='assets/images/logo/no-image.png';" type="audio/ogg">
            <source [src]="serverPath+value+cid" onerror="this.src='assets/images/logo/no-image.png';" type="audio/mpeg">
            <source [src]="serverPath+value+cid" onerror="this.src='assets/images/logo/no-image.png';" type="audio/mp3">
            <source [src]="serverPath+value+cid" onerror="this.src='assets/images/logo/no-image.png';" type="audio/*">
          Your browser does not support the audio element.
          </audio>
      </div>
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <button [attr.guide]="'audio-upload-btn-1' + '__' + sanitizedUrl" (click)="logo()" mat-raised-button>Upload</button>
    
        <button [attr.guide]="'audio-upload-btn-2' + '__' + sanitizedUrl" *ngIf="value!=''" (click)="deleteImage()" mat-raised-button>delete</button>
      </div>
    </div>
    <div *ngIf="!imageVisible&&!imageDelete" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;" fxLayout="row"
      fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <calsoft-common-file-upload-audio (fileUploadResult)=getResult($event) [type]="'courseAudio'">
      </calsoft-common-file-upload-audio>
      <button [attr.guide]="'audio-upload-btn-3' + '__' + sanitizedUrl" (click)="cancelUpload()" mat-raised-button>Cancel</button>
    </div>